import { createFileRoute, Outlet } from "@tanstack/react-router";

import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute("/_protected/superuser")({
  beforeLoad: ({ context, ...guard }) => {
    if (!context.user?.is_superuser) {
      denyRouteAccess(guard, "superuser");
    }
  },
  component: Outlet,
});
